// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { RUT_ERROR } from './constants';

export function setRutError(data) {
  return {
    type: RUT_ERROR,
    data: data,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case RUT_ERROR:
      return {
        ...state,
        rutError: action.data,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusPaymentDetails/redux/setRutError.js